import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './procurementDetail.css';

/**
 * Four-step navigation for the procurement detail page. Each step shows its
 * real completion flag from the API, not its position in the list.
 */
const ProcurementStepper = ({ steps, activeTab, onSelect }) => (
  <nav aria-label='Procurement steps'>
    <ol className='pd-stepper'>
      {steps.map((step, index) => (
        <li key={step.tab}>
          <button
            type='button'
            className={classnames('pd-step', {
              'is-done': step.done,
              'is-active': activeTab === step.tab,
            })}
            onClick={() => onSelect(step.tab)}
            disabled={step.locked}
            aria-current={activeTab === step.tab ? 'step' : undefined}
            title={step.locked ? step.lockedHint : undefined}
          >
            <span className='pd-step__num' aria-hidden='true'>
              {step.done ? (
                <i className='ri-check-line' />
              ) : step.locked ? (
                <i className='ri-lock-line' />
              ) : (
                index + 1
              )}
            </span>
            <span className='pd-step__text'>
              <span className='pd-step__label'>{step.label}</span>
              <span className='pd-step__state'>
                {step.done
                  ? 'Completed'
                  : step.locked
                    ? step.lockedHint
                    : step.hint}
              </span>
            </span>
          </button>
        </li>
      ))}
    </ol>
  </nav>
);

ProcurementStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      tab: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
      hint: PropTypes.string,
      done: PropTypes.bool,
      locked: PropTypes.bool,
      lockedHint: PropTypes.string,
    })
  ).isRequired,
  activeTab: PropTypes.number.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default ProcurementStepper;
